// extracted by mini-css-extract-plugin
export default {"root":"h8WmgaJB","icon":"KW5fEe2q","rightItem":"yxdpwMGG","spinner":"_o9pbmfe"};